import { ModalContainer } from "../../../../components/ui/ModalContainer";
import { useMemo, useState } from "react";
import { Link, useLocation } from "react-router";
import { Deal } from "../../../../types/pipeline";
import { DealInformation } from "../../../deals/DealInformation/components";
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import UpdateRoundedIcon from '@mui/icons-material/UpdateRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import CalendarViewDayRoundedIcon from '@mui/icons-material/CalendarViewDayRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

interface Props {
    deal: Deal;
    enableRottingIn: boolean;
    rottingInDays: number;
}

export function Card({ deal, enableRottingIn, rottingInDays }: Props) {
    const location = useLocation();

    const [openModal, setOpenModal] = useState<boolean>(false);

    const stageId = useMemo(() => parseInt(deal.stageId), []);

    const bgColor = enableRottingIn &&
        deal.diasEnStage > rottingInDays
        ? "bg-red-100"
        : "bg-white";

    const bgDiasEnStage = enableRottingIn &&
        deal.diasEnStage > rottingInDays
        ? "bg-red-700"
        : "bg-green-700";
    
    const handleOpenModal = () => {
        if(stageId == 1) return;
        setOpenModal(true)
    }

    return (
        <>
        <div 
            onClick={handleOpenModal}
            className={`border-0 border-gray-500 w-11/12 p-2 rounded shadow-sm ${bgColor} ${stageId != 1 ? "cursor-pointer": ""}`}>
            <p className="w-fit">
                {stageId == 1
                ?
                <Link
                    className="w-fit" 
                    to={`/empresa/${deal.empresaId}`}
                    state={{ fromName: "embudo", fromPath: location.pathname }}>
                    {deal.nombreEmpresa}
                </Link>
                : <>{deal.nombreEmpresa}</>
                }
            </p>

            <div className="flex items-center gap-[3px]">
                <CalendarMonthRoundedIcon sx={{ width: 15, height: 15, color: "#4b5563" }}/>
                <p className="text-[13px] text-gray-600">{deal.fechaVisita}</p>
            </div>

            <div className="flex items-center gap-[3px]">
                <UpdateRoundedIcon sx={{ width: 15, height: 15, color: "#4b5563" }}/>
                <p className="text-[13px] text-gray-600">{deal.frecuenciaVisita}</p>
            </div>

            <div className="flex my-1 gap-2">
                <div className="text-[13px]  bg-gray-800 rounded-full w-[20px] px-2 h-[20px] text-center"></div>

                <p className="text-[13px] text-white bg-gray-700 rounded-full w-fit px-[6px] h-[20px] text-center flex items-center gap-[3px]">
                    <AccessTimeRoundedIcon sx={{ width: 15, height: 15 }}/>
                    {`${deal.diasDesdeUltimaVisita}d`}
                </p>

                <p className={`${bgDiasEnStage} text-[13px] text-white rounded-full w-fit px-[6px] h-[20px] text-center flex items-center gap-[3px]`}>
                    <CalendarViewDayRoundedIcon sx={{ width: 15, height: 15 }}/>
                    {`${deal.diasEnStage}d`}
                </p>
            </div>
        </div>

        {openModal && (
        <ModalContainer>
            <div className="bg-white w-[1000px] rounded max-h-screen flex flex-col">
                <div className="flex justify-end bg-gray-100 rounded h-[26px]">
                    <button onClick={() => setOpenModal(false)}>
                        <CloseRoundedIcon />
                    </button>
                </div>

                <DealInformation 
                    deal={deal} />
            </div>
        </ModalContainer>
        )}
        </>
    );
}
